import { useApi } from '@/api';
import { ChartTimeFilter } from '@/components';
import { Flex, Card, ChartSkeleton, DisplaySwitch } from '@blockanalitica/ui';
import { useMemo, useState } from 'react';
import { useParams } from 'react-router';
import HistoricGraphs from './HistoricGraphs';
import { SimpleChartData } from '@blockanalitica/ui/package/types/src/components/charts/SimpleChart';

type MarketHistory = {
  results: SimpleChartData[];
  name: string;
  symbol: string;
};

export default function HistoricTabs({
  underlyingSymbol,
  underlyingAddress,
  network
}: {
  underlyingSymbol: string;
  underlyingAddress: string;
  network: string;
}) {
  const { marketAddress } = useParams();
  const [activeDisplayOption, setActiveDisplayOption] =
    useState('total_supply');
  const [chartDaysAgo, setChartDaysAgo] = useState('30');
  const displayOptions = useMemo(
    () => [
      { key: 'total_supply', value: 'Supply' },
      { key: 'total_borrow', value: 'Borrow' },
      { key: 'available_liquidity', value: 'Available' }
    ],
    []
  );

  const [data, error] = useApi<MarketHistory>({
    url: `/markets/${marketAddress}/historic/`,
    queryParams: {
      days_ago: chartDaysAgo
    }
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return <ChartSkeleton />;
  }

  return (
    <Card flexDirection="column" gap="xs">
      <Flex
        justifyContent="space-between"
        flexDirection={['column', 'row']}
        alignItems={['center', 'flex-start']}
        gap={['xs', 'm']}>
        <DisplaySwitch
          data={displayOptions}
          activeOption={activeDisplayOption}
          onChange={setActiveDisplayOption}
        />
        <ChartTimeFilter
          activeOption={chartDaysAgo}
          onChange={setChartDaysAgo}
        />
      </Flex>
      <HistoricGraphs
        data={data.results}
        type={activeDisplayOption}
        underlyingSymbol={underlyingSymbol}
        underlyingAddress={underlyingAddress}
        network={network}
        chartDaysAgo={chartDaysAgo}
      />
    </Card>
  );
}
